import type { StyleRule } from '@archipro-design/aria';
import { HeaderClassName, pxToRem } from '@archipro-design/aria';

export const HeaderContainer: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: `0 0 ${pxToRem(130)} 0`,
    paddingTop: `0 !important`,
    borderTop: `1px solid ${theme.siteVariables.colors.primitive.black}`,
    [theme.screen.tablet]: {
        margin: `${pxToRem(69)} 0 ${pxToRem(130)} 0`,
    },
});

export const HeaderContainerInner: StyleRule = () => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: pxToRem(-69),
});

export const Header: StyleRule = ({ theme }) => ({
    [`&.${HeaderClassName}`]: {
        width: pxToRem(420),
        marginTop: pxToRem(67 + 69),
        marginBottom: pxToRem(50),
        lineHeight: theme.siteVariables.lineHeightDefault,
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        color: theme.siteVariables.colorScheme.default?.foreground,
        textTransform: 'uppercase',
        fontSize: pxToRem(22),
    },
});

export const CompanyLogoWrapper: StyleRule = () => ({
    width: pxToRem(896),
});

export const CompanyLogoContainer: StyleRule = () => ({
    position: 'relative',
});
